<template>
  <div class="paper-choice-set-stu-class" v-loading="loading" element-loading-text="加载中，请稍等...">
    <div class="cont" v-if="guideTeachers">
      <div class="teacher-main">
        <div class="main">
          <div class="main-cont">
            <DataGrid size="mini"
                      height="auto"
                      border="none"
                      highlight-hover-row
                      show-overflow="title"
                      show-header-overflow="title"
                      row-id="id"
                      :tree-config="{expandAll: false, reserve: true}"
                      :data="guideTeachers"
                      :row-class-name="getGroupClassName">
              <DataGridColumn width="30px" align="center" tree-node></DataGridColumn>
              <DataGridColumn title="指导教师">
                <template #default="{level, row}">
                  <template v-if="level === 0">
                  <span class="teacher-label">
                    <span>{{row.name}}</span>
                  </span>
                  </template>
                </template>
              </DataGridColumn>
              <DataGridColumn title="班级（班级人数）"
                              width="25%"
                              align="center">
                <template #default="{level, row}">
                  <template v-if="level === 0">
                    <PaperChoiceSetStuClassMerge :guide-teacher="row"></PaperChoiceSetStuClassMerge>
                  </template>
                  <template v-else>
                    <div class="banji-label">
                      <span>{{row.banji}}</span>
                      <span>（{{row.stuCount}}）</span>
                    </div>
                  </template>
                </template>
              </DataGridColumn>
              <DataGridColumn title="最多指导人数"
                              width="150px"
                              align="center">
                <template #default="{level, row}">
                  <template v-if="level === 0">
                    <el-input-number v-model.number="row.leadMaxCount"
                                    size="mini"
                                    :precision="0"
                                    :step="1"
                                    :min="row.distributeCount || 1"
                                    placeholder="指导名额"></el-input-number>
                  </template>
                  <template v-else>
                    <el-input-number v-model.number="row.leadCount"
                                    size="mini"
                                    :precision="0"
                                    :step="1"
                                    :min="1"
                                    placeholder="限选人数"></el-input-number>
                  </template>
                </template>
              </DataGridColumn>
              <DataGridColumn title="操作"
                              width="150px"
                              align="center">
                <template #default="{level, row}">
                  <div v-if="level === 0"
                      class="btn-group">
                    <el-button size="mini"
                              type="text"
                              :disabled="row.deleting"
                              @click="handleDeleteTeacher(row)">删除</el-button>
                  </div>
                </template>
              </DataGridColumn>
            </DataGrid>
          </div>
        </div>
        <div v-if="guideTeachers && guideTeachers.length"
            class="footer">
          <el-button size="mini"
                    type="primary"
                    :loading="committing"
                    @click="handleApply">{{committing ? '提交中...' : '提交分配'}}</el-button>
        </div>
      </div>
      <div class="distribute-main">
        <div class="header">
          <span class="title">分配状况</span>
        </div>
        <div class="main-cont">
          <div class="teacher-dist">
            <div class="body">
              <DataGrid size="mini"
                        height="auto"
                        border="none"
                        stripe
                        highlight-hover-row
                        show-overflow="title"
                        show-header-overflow="title"
                        :data="guideTeachers">
                <DataGridColumn title="指导老师"
                                width="40%"
                                field="name"></DataGridColumn>
                <DataGridColumn title="指导名额 | 已分配 | 剩余名额"
                                width="60%"
                                align="center">
                  <template #default="{row}">
                    <span class="quota">{{row.leadMaxCount || '--'}}</span>
                    <span>|</span>
                    <span class="quota">{{row.distributeCount || 0}}</span>
                    <span>|</span>
                    <span :class="['quota', {'is-warning': row.leadMaxCount > (row.distributeCount || 0)}]">
                    <template v-if="typeof row.leadMaxCount === 'number'">
                      {{row.leadMaxCount - (row.distributeCount || 0)}}
                    </template>
                  </span>
                  </template>
                </DataGridColumn>
              </DataGrid>
            </div>
          </div>
          <div class="banji-dist">
            <div class="body">
              <DataGrid size="mini"
                        height="auto"
                        border="none"
                        stripe
                        highlight-hover-row
                        show-overflow="title"
                        show-header-overflow="title"
                        :data="guideClasses">
                <DataGridColumn title="班级名称"
                                field="banji"
                                width="40%"></DataGridColumn>
                <DataGridColumn title="班级人数 | 已分配 | 剩余人数"
                                width="60%"
                                align="center">
                  <template #default="{row}">
                    <span class="quota">{{row.stuCount}}</span>
                    <span>|</span>
                    <span :class="['quota', {'is-warning': (banjiDistribute[row.banji] || 0) > row.stuCount}]">
                    {{banjiDistribute[row.banji] || 0}}
                  </span>
                    <span>|</span>
                    <span :class="['quota', {'is-danger': row.stuCount > (banjiDistribute[row.banji] || 0)}]">
                    {{Math.max(row.stuCount - (banjiDistribute[row.banji] || 0), 0)}}
                  </span>
                  </template>
                </DataGridColumn>
              </DataGrid>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-else>
        <Hint v-if="!loading"
              type="error">
          <div>教师分配数据加载失败</div>
          <el-button type="text"
                    @click="loadData">重新加载</el-button>
        </Hint>
      </template>
  </div>
</template>

<script>
import DataGrid from '../../../../../../../elements/DataGrid'
import DataGridColumn from '../../../../../../../elements/DataGridColumn'
import PaperChoiceSetStuClassMerge from './merge'
import Hint from '../../../../../../../elements/Hint'
export default {
  name: 'PaperChoiceSetStuClass',
  components: {
    DataGrid,
    DataGridColumn,
    PaperChoiceSetStuClassMerge,
    Hint
  },
  props: {
    paperBatchId: {
      type: String,
      required: true
    },
    activeTab: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      guideTeachers: null,
      guideClasses: null,
      banjiDistribute: {},
      committing: false
    }
  },
  methods: {
    loadData () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/paper/choice/set/queryTeacherClass',
        method: 'post',
        data: this.$qs.stringify({
          paperBatchId: this.paperBatchId
        })
      }).then(response => {
        if (response.data && response.data.errorCode === 0) {
          this.initGuideDistribute(response.data.guideTeachers || [], response.data.guideBanjis || [])
        } else {
          this.$message.error(response.data.message || '加载失败')
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    initGuideDistribute (guideTeachers, guideBanjis) {
      this.guideTeachers = guideTeachers.map(guideTeacher => {
        guideTeacher.distributeCount = guideTeacher.stuNum
        let distribute = guideTeacher.distribute || {}
        let children = []
        guideBanjis.forEach(guideClass => {
          children.push({
            id: `${guideTeacher.id}-${guideClass.banji}`,
            guideTeacherId: guideTeacher.id,
            leadCount: distribute[guideClass.banji],
            ...guideClass
          })
        })
        return {
          children,
          ...guideTeacher
        }
      })
      this.guideClasses = guideBanjis
    },
    calcBanjiDistribute () {
      let guideTeachers = this.guideTeachers
      if (guideTeachers) {
        let banjiDistribute = {}
        guideTeachers.forEach(guideTeacher => {
          let children = guideTeacher.children
          if (children) {
            children.forEach(item => {
              if (item.leadCount) {
                banjiDistribute[item.banji] = (banjiDistribute[item.banji] || 0) + item.leadCount
              }
            })
          }
        })
        this.banjiDistribute = banjiDistribute
      }
    },
    getGroupClassName ({rowLevel, row}) {
      if (rowLevel === 0) {
        return 'guide-teacher-row'
      }
    },
    handleDeleteTeacher (guideTeacher) {
      this.$confirm('确定要删除选择的指导教师吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$set(guideTeacher, 'deleting', true)
        this.$ajax({
          url: '/workspace/manager/paper/choice/set/delTeacherClass',
          method: 'post',
          data: this.$qs.stringify({
            id: guideTeacher.id
          })
        }).then(response => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.$message.success(response.data['message'])
                let guideTeachers = this.guideTeachers
                if (guideTeachers) {
                  let index = guideTeachers.findIndex(item => item.id === guideTeacher.id)
                  if (index >= 0) {
                    guideTeachers.splice(index, 1)
                  }
                }
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.$set(guideTeacher, 'deleting', false)
        })
      }).catch(() => {})
    },
    handleApply () {
      let guideTeachers = this.guideTeachers
      if (guideTeachers && guideTeachers.length) {
        let isValid = guideTeachers.every(guideTeacher => {
          if (typeof guideTeacher.leadMaxCount !== 'number') {
            this.$message.warning(`指导教师“${guideTeacher.name}”指导人数未完善`)
            return
          }
          return true
        })
        if (!isValid) {
          return
        }
        this.committing = true
        this.$ajax({
          url: '/workspace/manager/paper/choice/set/saveTeacherClass',
          method: 'post',
          data: this.$qs.stringify(this.$extend({
            paperBatchId: this.paperBatchId,
            distribute: JSON.stringify({
              guides: guideTeachers.map(guideTeacher => {
                let children = guideTeacher.children
                let distributes = {}
                if (children && children.length) {
                  children.forEach(guideClass => {
                    if (typeof guideClass.leadCount === 'number') {
                      distributes[guideClass.banji] = guideClass.leadCount
                    }
                  })
                }
                return {
                  id: guideTeacher.id,
                  leadMaxCount: guideTeacher.leadMaxCount,
                  distributes
                }
              })
            })
          }))
        }).then(response => {
          if (response.data && response.data.errorCode === 0) {
            this.$message.success(response.data['message'] || '分配成功')
          } else {
            this.$message.warning(response.data.message || '分配失败')
          }
        }, () => {
          this.$message.error('分配失败')
        }).finally(() => {
          this.committing = false
        })
      } else {
        this.$message.warning('未分配指导教师')
      }
    }
  },
  watch: {
    activeTab: {
      handler (val) {
        if (val) {
          this.loadData()
        }
      },
      immediate: true
    },
    guideTeachers: {
      handler: function () {
        this.calcBanjiDistribute()
      },
      deep: true
    },
    paperBatchId: {
      handler () {
        if (!this.activeTab) {
          return
        }
        this.loadData()
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../styles/color";
.paper-choice-set-stu-class{
  height: 100%;
  & > .cont{
    height: 100%;
    display: flex;
    & > .teacher-main {
    flex: 3;
    display: flex;
    flex-direction: column;
    & > .main {
      flex: auto;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        .vxe-table {
          .vxe-table--header-wrapper {
            .vxe-table--header {
              .vxe-header--row {
                background-color: #f3f4f6;
                .vxe-header--column {
                  height: 40px;
                  padding: 0;
                }
              }
            }
          }
          .vxe-table--body-wrapper {
            .vxe-table--body {
              .vxe-body--row {
                &.guide-teacher-row {
                  font-weight: bold;
                  background-color: #f9f9fa;
                }
                .vxe-body--column {
                  position: relative;
                  height: 42px;
                  padding: 0;
                  .vxe-cell {
                    .vxe-tree--btn-wrapper {
                      background-color: transparent;
                    }
                    .el-input-number {
                      width: 112px;
                      .el-input-number__increase,
                      .el-input-number__decrease {
                        width: 22px;
                      }
                      .el-input__inner {
                        font-weight: bold;
                        border-radius: 0;
                        padding-left: 22px;
                        padding-right: 22px;
                      }
                    }
                    .teacher-label {
                      color: #303133;
                    }
                    .banji-label {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      font-weight: bold;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    & > .footer {
      flex: none;
      border-top: 1px solid #f3f4f5;
      padding: 10px 15px;
      text-align: center;
      .el-button {
        margin: 0 5px;
      }
    }
  }
    & > .distribute-main {
      margin-left: 15px;
      flex: 1;
      min-width: 320px;
      border-left: 1px solid #f3f4f6;
      display: flex;
      flex-direction: column;
      & > .header {
        flex: none;
        height: 40px;
        background-color: #f3f4f6;
        text-align: center;
        line-height: 40px;
        box-sizing: border-box;
        & > .title {
          font-size: 12px;
          font-weight: bold;
        }
      }
      & > .main-cont {
        flex: auto;
        display: flex;
        flex-direction: column;
        & > .teacher-dist,
        & > .banji-dist {
          flex: 1;
          position: relative;
          border-top: 1px solid #f3f4f6;
          & > .body {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            .vxe-table {
              .vxe-table--header-wrapper {
                .vxe-table--header {
                  .vxe-header--row {
                    background-color: #f9f9fa;
                    .vxe-header--column {
                      height: 40px;
                      padding: 0;
                    }
                  }
                }
              }
              .vxe-table--body-wrapper {
                .vxe-table--body {
                  .vxe-body--row {
                    .vxe-body--column {
                      .vxe-cell {
                        .quota {
                          display: inline-block;
                          min-width: 30px;
                          text-align: center;
                          &.is-warning {
                            color: $set-warning-color;
                          }
                          &.is-danger {
                            color: $set-danger-color;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
